<template>
  <el-form ref="form" :model="form" :rules="rules" size="mini">
    <p class="text-red-600 text-sm pb-2">如实填入以下能源消耗，点击确认按钮自动计算变化情况。</p>
    <el-table :data="list" class="h-96 overflow-auto">
      <el-table-column align="left" label="能源名称" prop="name">
        <template v-slot="scope">
          <div>{{scope.row.name}}(<span class="text-red-300 text-xs">单位:{{scope.row.unit}}</span>)</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="数字化改造前消耗">
        <template v-slot="scope">
          <el-input-number :min="0" v-model="form[scope.row.key].b" @change="val => !val && (form[scope.row.key].b = 0)" />
        </template>
      </el-table-column>
      <el-table-column align="center" label="数字化改造后消耗">
        <template v-slot="scope">
          <el-input-number :min="0" v-model="form[scope.row.key].a" @change="val => !val && (form[scope.row.key].a = 0)" />
        </template>
      </el-table-column>
    </el-table>
    <el-form-item>
      <el-button v-if="!isView" @click="handleSave" type="primary">确认</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { getRevenueList, getRevenueNewList } from '@/api/enterprise'

export default {
  props: ['ans', 'isView', 'cb', 'userId'],
  data () {
    return {
      form: {
        k1: { a: 0, b: 0 },
        k2: { a: 0, b: 0 },
        k3: { a: 0, b: 0 },
        k4: { a: 0, b: 0 },
        k5: { a: 0, b: 0 },
        k6: { a: 0, b: 0 },
        k7: { a: 0, b: 0 },
        k8: { a: 0, b: 0 },
        k9: { a: 0, b: 0 },
        k10: { a: 0, b: 0 },
        k11: { a: 0, b: 0 },
        k12: { a: 0, b: 0 },
        k13: { a: 0, b: 0 },
        k14: { a: 0, b: 0 },
        k15: { a: 0, b: 0 }
      },
      rules: {
        before: { required: true, message: '请输入有效的消耗', trigger: 'blur' },
        after: { required: true, message: '请输入有效的消耗', trigger: 'blur' }
      },
      list: [
        {
          name: '原煤（无烟煤）',
          unit: '吨',
          key: 'k1',
          co: 0.9428
        },
        {
          name: '原煤（炼焦烟煤）',
          key: 'k2',
          unit: '吨',
          co: 0.9
        },
        {
          name: '原煤（一般烟煤）',
          key: 'k3',
          unit: '吨',
          co: 0.7143
        },
        {
          name: '原煤（褐煤）',
          key: 'k4',
          unit: '吨',
          co: 0.4286
        },
        {
          name: '洗精煤',
          key: 'k5',
          unit: '吨',
          co: 0.9
        },
        {
          name: '高炉煤气',
          key: 'k6',
          unit: '万立方米',
          co: 1.286
        },
        {
          name: '转炉煤气',
          key: 'k7',
          unit: '万立方米',
          co: 2.714
        },
        {
          name: '其他煤气',
          key: 'k8',
          unit: '万立方米',
          co: 1.786
        },
        {
          name: '电力',
          key: 'k9',
          unit: '万千瓦时',
          co: 1.229
        },
        {
          name: '热力',
          key: 'k10',
          unit: '百万千焦',
          co: 0.0341
        },
        {
          name: '余热余压',
          key: 'k11',
          unit: '百万千焦',
          co: 0.0341
        },
        {
          name: '城市生活垃圾（用于燃料）',
          key: 'k12',
          unit: '吨',
          co: 0.2714
        },
        {
          name: '工业废料（用于燃料）',
          key: 'k13',
          unit: '吨',
          co: 0.4285
        },
        {
          name: '生物质能（用于燃料）',
          key: 'k14',
          unit: '吨标准煤',
          co: 1
        },
        {
          name: '其他燃料',
          key: 'k15',
          unit: '吨标准煤',
          co: 1
        }
      ]
    }
  },
  computed: {
    sum () {
      return this.list.reduce((obj, item) => {
        obj.a += this.form[item.key].a * item.co
        obj.b += this.form[item.key].b * item.co
        return obj
      }, { a: 0, b: 0 })
    }
  },
  mounted () {
    this.loadYear().then(() => {
      this.form = Object.assign({}, this.form, this.ans)
    })
  },
  methods: {
    loadYear () {
      return !Object.keys(this.ans).includes('revenue2023') ? getRevenueNewList(this.userId).then(res => {
        const revenue = res.data.sort((a, b) => a.year * 1 > b.year * 1 ? 1 : -1)
        const { personRevenue: personRevenue2023, year: year2023 } = revenue[2]
        const { personRevenue: personRevenue2022, year: year2022 } = revenue[1]
        this.$set(this.form, 'revenue', [personRevenue2022, personRevenue2023])
        this.$set(this.form, 'year', [year2022, year2023])
        this.$set(this.form, 'version', 1)
      }) : getRevenueList(this.userId).then(res => {
        const { personRevenue: personRevenue2023 } = res.data.find(v => v.year === '2023') || { personRevenue: 0, personCount: 0 }
        const { personRevenue: personRevenue2022 } = res.data.find(v => v.year === '2022') || { personRevenue: 0, personCount: 0 }
        this.$set(this.form, 'revenue2023', personRevenue2023)
        this.$set(this.form, 'revenue2022', personRevenue2022)
      })
    },
    handleSave () {
      this.$refs.form.validate(valid => {
        if (valid) {
          const [revenue2022, revenue2023, year2023] = this.form.version ? this.form.revenue.concat(this.form.year[1]) : [this.form.revenue2022, this.form.revenue2023, 2023]
          const beforeCost = revenue2022 * 1 === 0 ? 0 : (this.sum.b / revenue2022 * 10000)
          const afterCost = revenue2023 * 1 === 0 ? 0 : (this.sum.a / revenue2023 * 10000)

          if ((revenue2022 * 1 !== 0 && this.sum.b < 1) || (revenue2023 * 1 !== 0 && this.sum.a < 1)) {
            this.$confirm('无效的能耗数据，请查阅《能源购进、消费与库存》（205-1表）和《能源加工转换与回收利用》（205-2表）再填入相应的数据！', '提示', {
              confirmButtonText: '确定',
              showClose: false,
              showCancelButton: false,
              type: 'warning'
            })
            return
          }

          let result = afterCost > beforeCost ? 1 : (afterCost === beforeCost ? 0 : -1)

          if (revenue2022 * 1 === 0) {
            result = 0
          }
          if (revenue2023 * 1 === 0) {
            result = 1
          }
          this.$set(this.form, 'result', result)
          this.$set(this.form, 'before', this.sum.b)
          this.$set(this.form, 'after', this.sum.a)
          this.$set(this.form, 'beforeCost', beforeCost)
          this.$set(this.form, 'afterCost', afterCost)
          this.cb(this.form, year2023)
        }
      })
    }
  }
}
</script>
